export default __webpack_public_path__ + "0c1e4c2eb0097cc289f69a7471e5abee.jpg";